import React, { useState } from 'react'
import { View } from 'styles/reactnative'

import { AdminTableHeader } from 'app/components'
import AdminWithdrawalTable from './AdminWithdrawalTable'
import AdminSubTitle from '../../../components/AdminSubTitle'
import { AdminWithdrawalTableColumn } from './AdminWithdrawalTableColumn'
import TableAPI from '../../../components/TableAPI'
import { Button, Input, Popover, Select, Space } from 'antd'
import { CloseOutlined, SearchOutlined } from '@ant-design/icons'
import { useUserList } from '../../../hooks/user/userlist'

const AdminWithdrawalManagement = ({ title, type }: any) => {
	const params = new URLSearchParams(window.location.search)
	const idquery = params.get('userid')
	const process = params.get('process')

	const [user_id, setUser_id] = useState<any>(idquery || '')
	const [status, setStatus] = useState<any>(process || '')

	const makeurl = (check, query) => {
		if (check) {
			return `&${query}=${check}`
		} else {
			return ''
		}
	}

	const { usertype1 } = useUserList()

	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					flexDirection: 'row',
					backgroundColor: 'white',
					width: '100%',
					padding: 10,
					marginTop: 10,
					borderTopLeftRadius: 10,
					borderTopRightRadius: 10,
				}}>
				<Button
					type="primary"
					style={{ marginRight: 10 }}
					onClick={() => {
						setStatus('')
						setUser_id('')
					}}>
					전체보기
				</Button>
				<Select
					value={status}
					onChange={e => {
						setStatus(e)
					}}
					filterOption={true}
					options={[
						{ value: '', label: '진행상태' },
						{ value: '1', label: '승인대기' },
						{ value: '3', label: '검토중' },
						{ value: '4', label: '거절' },
						{ value: '2', label: '입금완료' },
					]}
					style={{ marginRight: 10 }}
				/>
				<Space.Compact direction="horizontal">
					<Popover
						placement="bottom"
						trigger={'click'}
						content={
							<Space style={{ alignItems: 'center' }}>
								<Select
									style={{ width: '100%', minWidth: 200 }}
									defaultValue={''}
									onChange={e => {
										setUser_id(e)
									}}
									options={[
										{ value: '', label: '전체' },
										...(usertype1 || []),
									]}
								/>
							</Space>
						}>
						<Input
							placeholder="회원코드"
							value={user_id}
							onChange={e => {
								setUser_id(e.target.value)
							}}
						/>
					</Popover>
					<Button
						onClick={() => {
							setUser_id('')
						}}
						style={{ paddingTop: 0 }}
						size="small">
						{user_id ? <CloseOutlined /> : <SearchOutlined />}
					</Button>
				</Space.Compact>
			</View>

			<TableAPI
				title={title}
				columns={AdminWithdrawalTableColumn}
				usermodal={true}
				height={'default'}
				width={1400}
				apikey={`/admin/user/withdraw?t=${makeurl(
					user_id,
					'userid'
				)}${makeurl(status, 'process')}&t=`}
			/>
		</View>
	)
}

export default React.memo(AdminWithdrawalManagement)
